import React, { useState } from 'react'
import './winner-content.scss'
import WinnerHeader from '../../molecules/winner-header/winner-header';
import WinnerAutopauta from '../../molecules/winner-autopauta/winner-autopauta';
import WinnerList from '../../molecules/winner-list/winner-list';
import ConcourseService from '../../../shared/services/concourse-service';
import Search from '../../atoms/search/search';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb'

const WinnerContent = props => {
    const dataService = '?competitionId=' + props.params.slug
    const [winners, setWinners] = useState([])
    const [letterSearch, setLetterSearch] = useState("")
    React.useEffect(() => {
        ConcourseService.getWinners(dataService).then(res => {

            if (res.status === 200) {
                setWinners(res.data)
            } else {
                setWinners([])
            }
        })
    }, [])

    const [searchInput, setSearchInput] = useState("")

    const showWSearch =()=>{
        for (let index = 0; index < winners.length; index++) {
            const numElements = winners[index].winners.length;
            if(numElements>50){
                return true
            }
        }
        return false
    }
    return (
        <div className="f-winner-content">
            <div className="f-breadcrum-position">
                <Breadcrumb mobile={props.mobile} />
            </div>
            <WinnerHeader params={props.params} />
            <div className="f-winner-content-pink-container" />
            <div className="f-winner-content-reverseMobile">
                <WinnerAutopauta autopauta={props.params.autopauta[0].articulosRelacionados} />
                <div className="f-winner-content-list">
                    <div className="f-winner-content-list-content">
                        {showWSearch() && <Search searchInput={searchInput} setSearchInput={setSearchInput} letterSearch={letterSearch} setLetterSearch={setLetterSearch} />}
                        <WinnerList winners={winners} searchInput={searchInput} letterSearch={letterSearch} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WinnerContent
